export default {
  'groupingsAccountPayable.list.header.code': 'Código',
  'groupingsAccountPayable.list.header.description': 'Descrição',
  'groupingsAccountPayable.list.header.installments': 'Número de Parcelas',
  'groupingsAccountPayable.list.header.amount': 'Valor Total',
  'groupingsAccountPayable.list.header.actions': 'Ações',

  'groupingsAccountPayable.generate.clusters': 'Gerar Agrupamento',
  'groupingsAccountPayable.generate.searchAccounts': 'Buscar Contas',

  'groupingsAccountPayable.form.company': 'Empresa',
  'groupingsAccountPayable.form.creditor': 'Credor',
  'groupingsAccountPayable.form.supplier': 'Fornecedor',
  'groupingsAccountPayable.form.employee': 'Funcionário',
};
